(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["beamford-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('beamford-product-details')) {
customElements.define('beamford-product-details', class extends HTMLElement {
connectedCallback() {
this.section = this.closest('.shopify-section');
this.onProduct = (event) => {
if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
event.promise?.then((result) => {
const fresh = result?.detail?.html?.querySelector('beamford-product-details [data-specifications]');
const current = this.querySelector('[data-specifications]');
if (fresh && current) current.innerHTML = fresh.innerHTML;
}).catch(() => {});
};
this.section?.addEventListener('shopify:product:select', this.onProduct);
}
disconnectedCallback() {
this.section?.removeEventListener('shopify:product:select', this.onProduct);
}
});
}
if (!customElements.get('beamford-sticky-measure')) {
customElements.define('beamford-sticky-measure', class extends HTMLElement {
connectedCallback() {
this.frame = requestAnimationFrame(() => {
this.details = this.parentElement?.querySelector(':scope > .product-details');
if (!this.details) return;
const measure = () => this.details.style.setProperty('--beamford-details-height', this.details.getBoundingClientRect().height + 'px');
this.observer = new ResizeObserver(measure);
this.observer.observe(this.details);
measure();
});
}
disconnectedCallback() {
cancelAnimationFrame(this.frame);
this.observer?.disconnect();
}
});
}
  } catch(e) { console.error(e); }
})();

})();
